import React from 'react'
import { T, useT } from '@transifex/react'
import { AutoComplete } from 'src/antd'

import { APIURLS, baseUrl } from 'src/api/baseUrl'
import {
  FormRequiredProps,
  TCreateAntdFormElementsFormProps,
  useStore,
  WithFormInitializer,
} from 'src/new-components/antdform-kit-v2'
import {
  FormUI,
  FormFooter,
  FormItemUI,
  FormSection,
} from 'src/new-components/antdform-ui'
import { VALIDATORS } from 'src/new-components/antdform-utils/validation'
import { Opt } from 'src/new-components/select'

import { overrideApiUrl } from './state'

const apiUrlsOptions: Opt[] = [
  {
    label: <T _str="Production" />,
    value: APIURLS.production,
  },
  {
    label: <T _str="Staging" />,
    value: APIURLS.staging,
  },
  {
    label: <T _str="Development" />,
    value: APIURLS.development,
  },
  {
    label: <T _str="Preview" />,
    value: APIURLS.preview,
  },
]

export type TFormAppUrlChangeProps = {
  onCancel?: () => void
} & FormRequiredProps &
  Pick<TCreateAntdFormElementsFormProps, 'initMode'>

export type TFormAppUrlChangeSchema = {
  apiUrl: string
}

const FormAppUrlChange = WithFormInitializer<TFormAppUrlChangeProps>(
  ({ formId, initMode = 'edit', onCancel }) => {
    const createMode = true
    const t = useT()
    const mode = useStore((store) => store[formId].mode)

    const onSubmit = ({ apiUrl }: TFormAppUrlChangeSchema) => {
      overrideApiUrl(apiUrl)
      window.location.reload()
    }

    const formDisabled = mode === 'view'

    const initialValues: TFormAppUrlChangeSchema = {
      // get hostname from the baseUrl
      apiUrl: baseUrl.replace(/^(?:https?:\/\/)?(?:www\.)?/i, ''),
    }

    return (
      <FormUI
        requiredMark="optional"
        formId={formId}
        msgSuccessName={<T _str="API URL" />}
        createMode={createMode}
        initialValues={initialValues}
        initMode={initMode}
        footer={<FormFooter createEditBtnProps={{ onClick: onCancel }} />}
        onFinish={onSubmit}
      >
        <FormSection>
          <FormItemUI
            name="apiUrl"
            label={<T _str="Url" />}
            rules={[VALIDATORS.required, VALIDATORS.hostName]}
            size="x-large"
          >
            <AutoComplete
              options={apiUrlsOptions}
              placeholder={t(`Url`)}
              disabled={formDisabled}
            />
          </FormItemUI>
        </FormSection>
      </FormUI>
    )
  }
)

export { FormAppUrlChange }
